/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_GrammarInputs */



/**
* | output |
* | --- |
* | "Grammar/Spelling" |
*
* @param {Manual_Qc_Type_GrammarInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_grammar = /** @type {((inputs?: Manual_Qc_Type_GrammarInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_GrammarInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Grammaire/orthographe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Grammatik/Rechtschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Grammatica/Ortografia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Грамматика/орфография")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gramática/Ortografía")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("语法/拼写")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文法/スペル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("व्याकरण/वर्तनी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gramática/Ortografia")
	return /** @type {LocalizedString} */ ("Grammar/Spelling")
});